import React from 'react';
import { Card, Row, Col, Form, Badge } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { numericKeydownHandler } from '../../../utilities/common';
import { formatNumber } from '../../reports/reportHelper';
import { formatCo2eFactor } from '../scenarioConfig';

const GreenTariffPpaForm = ({ baseline, mode }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const elec = baseline?.data?.energy;

  return (
    <>
      <Card className="mb-4">
        <Card.Body>
          <div className="font-weight-bold mb-3">
            {t('CarbonView Data')}
          </div>

          <Row>
            <Col md={6}>
              <div className="text-muted small">
                {t('Annual Electricity Use')}
              </div>
              <div className="font-weight-medium">
                {elec
                  ? `${formatNumber(elec.consumption)} ${elec.unit || 'kWh'}/year`
                  : '...'}
              </div>
            </Col>

            <Col md={6}>
              <div className="text-muted small">
                {t('Grid Emission Factor')}
              </div>
              <div className="font-weight-medium">
                {elec
                  ? `${formatCo2eFactor(elec.emissionFactor)} tCO₂e/${elec.unit || 'kWh'}`
                  : '...'}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className="font-weight-bold">
              {t('Green Energy Options')}
            </div>
            <Badge variant="success">
              {t('Required')}
            </Badge>
          </div>

          <div className="text-muted small mb-4">
            {t('Define green tariff premium or PPA pricing')}
          </div>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  {t('Green Tariff (£/kWh)')} <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('e.g., 0.015')}
                  onKeyDown={numericKeydownHandler}
                  {...register('greenTariffPremium')}
                  disabled={mode === 'view'}
                  isInvalid={!!errors.greenTariffPremium}
                />
                <Form.Text className="text-muted">
                  {t('Additional cost per kWh for renewable energy or power Purchase Agreement fixed rate')}
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.greenTariffPremium?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  {t('Current Tariff (£/kWh)')} <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('e.g., 0.165')}
                  onKeyDown={numericKeydownHandler}
                  {...register('currentTariffRate')}
                  disabled={mode === 'view'}
                  isInvalid={!!errors.currentTariffRate}
                />
                <Form.Text className="text-muted">
                  {t('Current Tariff fixed rate')}
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.currentTariffRate?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default GreenTariffPpaForm;
